module.exports = __webpack_public_path__ + "static/9-8871311ed2e522f173c29b1098979be6.jpg";